export const POINT_CLICK_THRESHOLD = 0.001
export const HIGH_PRECISION_ZOOM_RANGE = [2, 5] // 200% -> 1000%
export const SIMPLIFICATION_EPSILON_RANGE = [0.1, 0.5]
